import { Modal } from "@mui/material";
import React, { useEffect } from "react";
import { archiveReportService } from "../../../services/ViewReportServices";
import styles from "./AcknowledgeDelete.module.scss";

const AcknowledgeDelete = ({
  openAcknowledgeDelete,
  closeAcknowledgeDelete,
  refresh,
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    closeAcknowledgeDelete();
  };

  useEffect(() => {
    if (
      openAcknowledgeDelete &&
      openAcknowledgeDelete.open &&
      openAcknowledgeDelete.sessionId
    ) {
      handleOpen();
    }
  }, [openAcknowledgeDelete]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={styles.AcknowledgeDeleteContainer}
    >
      <div className="bg-white w-[80vw] h-auto max-w-[500px] my-[100px] rounded-[10px] outline-none p-6">
        <div className="text-[#101828]  font-semibold text-xl leading-9 mb-5 text-center">
          Are you sure you want to Archive this report?
        </div>
        <div className="flex justify-center gap-4">
          <button
            className="
          text-[#fff]
          font-normal
          text-sm
          leading-5
          h-[30px]
          w-[80px]
          border-[1px]
          border-[#788CFC]
          rounded-[5px]
          bg-[#788CFC]
          transition
          duration-300
          ease-in-out
          flex
          justify-center
          items-center
        "
            onClick={() => {
              archiveReportService(openAcknowledgeDelete.sessionId, true).then(
                (res) => {
                  console.log(res);
                  refresh();
                  handleClose();
                }
              );
            }}
          >
            Archive
          </button>
          <button
            className="
          text-[#788CFC]
          font-normal
          text-sm
          leading-5
          h-[30px]
          w-[80px]
          border-[1px]
          border-[#788CFC]
          rounded-[5px]
          transition
          duration-300
          ease-in-out
          flex
          justify-center
          items-center
          "
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AcknowledgeDelete;
